import { AfterViewInit, Component, OnInit, AfterViewChecked, AfterContentInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-forum-single-topic',
  templateUrl: './forum-single-topic.component.html',
  styleUrls: ['./forum-single-topic.component.css']
})
export class ForumSingleTopicComponent implements OnInit, OnDestroy {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };
  businessID = this.route.snapshot.params.businessID;
  topicID = this.route.snapshot.params.id;
  topic_title = "";
  stream = [];
  has_before = false;
  has_after = false;
  last_post_number = 0;
  fist_post_number = 0;
  is_loading = false;

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }

    topics = [];

  ngOnInit(): void {
    var topic = JSON.parse(localStorage.getItem('topic'));

      this.fetchForumTopics(topic.last_read_post_number);
      this.topic_title = topic.title;
    
  }

  ngOnDestroy(): void {
    //delete topic from local storage
    localStorage.removeItem('topic');
  }


  fetchForumTopics(lastRead){
    console.log(this.topicID)
    this.http.get(environment.FORUM_TOPIC + '?topicID='+this.topicID + '&last_read_post_number=' + lastRead ,this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200){
          console.log(res.message);
          this.stream = res.stream;
          this.topics = res.message['post_stream']['posts'];
          this.checkHasBefore();
          this.checkHasAfter();
          this.last_post_number = this.topics[this.topics.length - 1].post_number;
          this.fist_post_number = this.topics[0].post_number;

          console.log(this.last_post_number, this.fist_post_number, 'vikke ja ekke')
          
          console.log(this.topics);
        }  
        else{
         
        }

      }, (err: any) => {
    
        console.log("Error while login :: ", err);
      })
  }

  checkHasBefore(){
    console.log(this.stream[0], this.topics[0].id)
    if(this.stream[0] != this.topics[0].id){
      this.has_before = true;
    }
    else{
      this.has_before = false;
    }
  }

  checkHasAfter(){
    console.log(this.stream[this.stream.length - 1], this.topics[this.topics.length - 1].id)
    if(this.stream[this.stream.length - 1] != this.topics[this.topics.length - 1].id){
      this.has_after = true;
      console.log('has after', this.has_after)
    }
    else{
      this.has_after = false;
      console.log('has after', this.has_after)
    }
  }

  checkBottom(){

    if(!this.is_loading){
    var element = document.getElementById('scroll-area');
    //If scroll position is at the bottom
    if(element.scrollHeight - element.scrollTop === element.clientHeight){
      console.log('bottom')
      this.is_loading = true;
      this.fetchMore();
    }
  }

  }

  postActions(post_action_type_id){
    console.log(post_action_type_id);
    
  }

  fetchMore(){
    if(this.has_after){

      var postIDs = 

      this.http.get(environment.FORUM_TOPIC + '?topicID='+this.topicID + '&last_read_post_number=' + this.last_post_number ,this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200){
            console.log(res.message);
            //Insert new posts to topics array so the user can scroll more
            this.topics = this.topics.concat(res.message['post_stream']['posts']);
            
            this.checkHasBefore();
            this.checkHasAfter();
            this.is_loading = false;
            this.last_post_number = this.topics[this.topics.length - 1].post_number;
            this.fist_post_number = this.topics[0].post_number;
            
            console.log(this.topics);
          }  
          else{
           
          }
  
        }, (err: any) => {
      
          console.log("Error while login :: ", err);
        })
    }
    else{
      console.log('no more')
    }
  }

}
